export const tipsWrapper = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
};

export const resendLinkButton = {
	px: '1.5rem',
	py: '1rem',
};

export const title = {
	textAlign: 'center',
};
